import useAsyncData from "../../../hooks/use-async-data";
import notificationService from "../../../utils/notification/notification.service";
import gpsService from "../gps.service";
import GpsPlanEntryRecords from "./gps-plan-entry-records";
import GpsPlanEntryRecordsError from "./gps-plan-entry-records-error";
import GpsPlanEntryRecordsParams from "./gps-plan-entry-records-params";

const useGpsPlanEntryRecords = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<GpsPlanEntryRecords | null>(null, false);

  const load = async (
    params: GpsPlanEntryRecordsParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const routeCompletedRoute = await gpsService.getPlanEntryRecords(
        params,
        signal,
      );

      setData(routeCompletedRoute);
    } catch (_error) {
      const error = _error as GpsPlanEntryRecordsError;
      notificationService.error(error.message);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useGpsPlanEntryRecords;
